const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  username: state => state.user.username,
  userid: state => state.user.userid,
  token: state => state.user.authorization,
  userRole: state => state.user.userRole,
  loading: state => state.permission.loading,
  introduction: state => state.user.introduction,
  errorLogs: state => state.errorLog.logs
}
export default getters
